import { createConfig } from "./config";


const config = createConfig();

export function getNodeTypes() {
    return [...Object.keys(config.nodeTypes), 'comment']
}